import React from "react";
import PropTypes from 'prop-types';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import _ from '../../../utils/ObjectUtils';

const DateField =
    ({
        value = "",
        label = "",
        handleFieldChange,
        handleFieldBlur = () => {
        },
        error,
        disabled = false,
        width = 6,
        min,
        max
    }) => {
         const handleKeypress = (e) => {
            e.preventDefault();
            return false
            }
        return (
            <div className={"col-lg-" + width + (width < 6 ? " col-md-6 " : " col-md-12 ")}>
                <FormControl
                    error={!_.isNilOrEmpty(error)}
                    disabled={disabled}
                >
                    <InputLabel
                        color="primary"
                        htmlFor="adornment-label"
                        shrink
                    >
                        {label}
                    </InputLabel>
                    <Input
                        id="adornment-label"
                        value={value}
                        type='date'

                        onChange={e => handleFieldChange(e.target.value)}
                        onKeyPress={(e) => handleKeypress(e)}
                        onBlur={handleFieldBlur}
                        aria-describedby="label-helper-text"
                        inputProps={{
                            "aria-label": "label",
                           
                            required: true,
                             min: min,
                             max : max
                           
                        }}
                    />
                    <FormHelperText id="label-helper-text">{error}</FormHelperText>
                </FormControl>
            </div>
        );
    };

DateField.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    handleFieldChange: PropTypes.func.isRequired,
    handleFieldBlur: PropTypes.func,
    error: PropTypes.string,
    themeName: PropTypes.string,
    minValue: PropTypes.any
};

export default DateField;